import React from "react";
import ConfirmModal from "components/ConfirmModal";
import { ModalProps } from "components/Modal";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import { rulesSetStore } from "../RulesSetStore";

interface RenameRulePopupProps extends ModalProps {
  ruleID: number;
}

const RemoveRulePopup = (props: RenameRulePopupProps) => {
  const { t } = useTranslation();

  const handleRemove = async () => {
    await rulesSetStore.removeRule(props.ruleID);
    props.close();
  };

  return (
    <ConfirmModal
      open={props.open}
      close={props.close}
      type="error"
      title={t("rulesEditor.removeRuleTitle")}
      confirmButtonTitle={t("rulesEditor.removeRule")}
      descriptionMesage={t("rulesEditor.removeRuleDescription")}
      onConfirm={handleRemove}
      containerClassName="md:min-w-[640px]"
      buttonClassName="bg-red-600 hover:!bg-red-700"
    ></ConfirmModal>
  );
};

export default observer(RemoveRulePopup);
